import { Reveal } from "./Reveal";
import { InlineReview } from "./Reviews";
import { HsaFsaSection } from "./HsaFsaSection";

const POLICIES = [
  "Please give at least 24 hours notice if you need to cancel or reschedule.",
  "Cancellations less than 24 hours before the appointment incur a $100 cancellation fee.",
];

export const PricingSection = ({ onContact }) => (
  <section id="pricing" data-testid="pricing-section" className="scroll-mt-20 py-16 sm:py-24 bg-[var(--brand-cream)] border-y border-[var(--brand-gold-soft)]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-[var(--brand-gold)] mb-3">
          Visit and pricing
        </p>
        <h2 className="font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)]">
          Know what to expect before you book.
        </h2>
      </Reveal>
      <div className="mt-10 grid lg:grid-cols-[1fr_1.2fr] gap-8">
        <Reveal delay={0.1}>
          <div data-testid="pricing-offer-card" className="bg-white border-2 border-[var(--brand-navy)] p-8 h-full">
            <p className="text-lg font-medium text-[var(--brand-navy-deep)]">
              Your first hormone or functional medicine visit
            </p>
            <p className="mt-2 text-lg">60 minutes with Dr. Crosson</p>
            <p className="mt-4 font-serif-brand text-5xl font-semibold text-[var(--brand-navy)]">$400</p>
            <div className="heartbeat-divider my-6" aria-hidden="true" />
            <p className="text-base leading-relaxed">
              We don&rsquo;t accept insurance. Our private-pay approach allows us to set aside time
              for a detailed, personal visit.
            </p>
            <p className="mt-4 text-base leading-relaxed text-[var(--brand-muted)]">
              Visits are billed at $100 per 15 minutes, based on time spent. A 60-minute visit is
              $400. You will never be billed for time not spent.
            </p>
            <p className="mt-4 text-base leading-relaxed text-[var(--brand-muted)]">
              We provide a superbill and receipt for your records, which you may submit to your
              insurance if you choose.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="bg-white border border-[var(--brand-gold-soft)] p-8 h-full">
            <h3 className="font-serif-brand text-2xl font-medium text-[var(--brand-navy)]">
              Scheduling and cancellations
            </h3>
            <p className="mt-3 text-base leading-relaxed">
              Choose a time that works for you, or call the office at (484) 544-3345 and the team
              will arrange your visit.
            </p>
            <ul data-testid="pricing-policy-list" className="mt-5 space-y-4">
              {POLICIES.map((p, i) => (
                <li key={i} className="flex gap-3 text-base leading-relaxed">
                  <span className="shrink-0 mt-1 h-2 w-2 bg-[var(--brand-gold)]" aria-hidden="true" />
                  {p}
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm text-[var(--brand-muted)]">
              Payment for your visit is collected at the practice. When you book, you can secure
              your appointment with an optional $25 deposit online &mdash; it&rsquo;s applied
              toward your visit.
            </p>
          </div>
        </Reveal>
      </div>
      <HsaFsaSection onContact={onContact} />
      <div className="mt-8">
        <Reveal>
          <InlineReview
            light
            testId="review-jane-domitrowits"
            quote="My visit with Dr. Crosson was a very positive experience because she took the time to listen and make sure my questions were answered in a way I could understand."
            name="Jane Domitrowits"
            sourceLabel="Verified Google Review"
            sidePhoto="/images/reviews/jane-domitrowits.webp"
            sidePhotoAlt="Jane Domitrowits with family"
            sidePhotoPosition="50% 25%"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
